import {boundMethod} from "autobind-decorator";
import React from "react";

import Modal, {CancelButton} from "@toolbox/modals/Modal";
import T from "@translate/T";
import RcaCalculator from "./RcaCalculator";

interface IRcaModalProps {
    speed: number;
    min: number;
    max: number;
    onChange(speed: number): void;
}

interface IRcaModalState {
    show: boolean;
}

class RcaModal extends React.PureComponent<IRcaModalProps, IRcaModalState> {
    public readonly state: IRcaModalState = {
        show: false,
    };

    public open() {
        this.setState({show: true});
    }

    @boundMethod
    public afterClose() {
        this.setState({show: false});
    }

    public render() {
        const {speed, min, max, onChange} = this.props;

        if (!this.state.show) {
            return null;
        }

        return (
            <Modal
                header={<T>RCA calculator</T>}
                notCentered={true}
                size="lg"
                afterClose={this.afterClose}
            >
                <div className="modal-body">
                    <RcaCalculator
                        rpm={speed}
                        minRpm={min}
                        maxRpm={max}
                        onRpmChange={onChange}
                    />
                </div>

                <div className="modal-footer">
                    <CancelButton>
                        <T>Close</T>
                    </CancelButton>
                </div>
            </Modal>
        );
    }
}

export default RcaModal;
